<template>
  <div class="home">
    <Header />

    <div class="carousel relative">
      <div class="carousel-inner relative overflow-hidden w-full">
        <input
          class="carousel-open"
          type="radio"
          id="carousel-1"
          name="carousel"
          aria-hidden="true"
          hidden
          checked
        />
        <div
          class="carousel-item absolute h-0 bg-cover bg-center justify-center"
          style="height: 22rem; background-image: url('tingey-injury.jpg')"
        >
          <div
            class="h-full w-full mx-auto flex pt-6 md:pt-0 items-center justify-center bg-black bg-opacity-50"
          >
            <h1 class="text-white text-4xl font-bold">Rechtsgebieden</h1>
          </div>
        </div>
      </div>
    </div>

    <section class="bg-white py-2 mt-4">
      <div class="container mx-auto flex flex-row items-center flex-wrap py-4">
        <div class="px-6 py-1 text-xl text-left w-full">
          <div
            class="mb-5 prose lg:prose-xl m-auto border border-gray-200 p-4 bg-gray-100 rounded"
          >
            <h3 style="color:#889176;" class="font-bold text-2xl mb-2">
              Het Strafrecht
            </h3>
            <p>
              Bent u een verdachte? In het strafrecht staan de termen
              ‘verdachte’ en ‘verdenking’ centraal. Je bent verdachte wanneer de
              politie je verdenkt van het (helpen en/of willen) plegen van een
              strafbaar feit. Jij of je kind zijn een verdachte wanneer je bent:
              aangehouden / bent uitgenodigd voor verhoor bij de politie / een
              strafbeschikking, een dagvaarding of een oproep voor een
              officierszitting hebt ontvangen / wanneer je rijbewijs is
              ingenomen of je een rijontzegging heeft gekregen. Dit zijn DE
              momenten om direct advies in te winnen.
              <br /><br />
              Ben jij of je kind aangehouden dan hebben jullie altijd recht op
              overleg met een advocaat voor het politieverhoor (we bespreken de
              zaak en je opstelling tijdens het verhoor, zwijgen of verklaren)
              en bijstand tijdens het verhoor. Mijn bezoek op het politiebureau
              is bijna altijd kosteloos.
              <br /><br />
              Ben je schriftelijk uitgenodigd voor een verhoor dan mag je altijd
              voor het verhoor overleggen met een advocaat en een advocaat
              meenemen naar het verhoor.
            </p>
          </div>
        </div>
      </div>
    </section>

    <section class="bg-white py-2">
      <div class="container mx-auto flex flex-row items-center flex-wrap py-4">
        <div class="px-6 py-1 text-xl text-left w-full">
          <div
            class="mb-5 prose lg:prose-xl m-auto border border-gray-200 p-4 bg-gray-100 rounded"
          >
            <h3 style="color:#889176;" class="font-bold text-2xl mb-2">
              Het Jeugdstrafrecht
            </h3>
            <p>
              <strong
                >JE HEBT ALS MINDERJARIGE ALTIJD RECHT OP GRATIS BIJSTAND VAN
                EEN ADVOCAAT.</strong
              >
              En maak daar gebruik van. Met je advocaat bespreek je de inhoud
              van je zaak en bepaal je je houding tijdens het verhoor. Soms is
              verklaren beter en soms zwijgen. De politie zegt natuurlijk altijd
              uit dat verklaren het beste is en dat je dan sneller naar huis
              mag. Maar dat is niet altijd waar en op de langere termijn kan je
              door verklaard te hebben zelf zorgen voor een eigen veroordeling.
              Tijdens het verhoor mag naast de advocaat ook een ouder aanwezig
              zijn.
              <br /><br />
              In het jeugdstrafrecht gaat het om minderjarige kinderen (van 12
              jaar tot 18 jaar en soms tot 23 jaar).
              <br /><br />
              De officier van justitie bepaalt of hij je gaat vervolgen en op
              welke wijze. De officier heeft hiertoe meerdere mogelijkheden.
            </p>
          </div>
        </div>
      </div>
    </section>

    <section class="bg-white py-2">
      <div class="container mx-auto flex flex-row items-center flex-wrap py-4">
        <div class="px-6 py-1 text-xl text-left w-full">
          <div
            class="mb-5 prose lg:prose-xl m-auto border border-gray-200 p-4 bg-gray-100 rounded"
          >
            <h3 style="color:#889176;" class="font-bold text-2xl mb-2">
              Het Jeugdrecht
            </h3>
            <p>
              Het jeugdrecht is een aparte specialisatie. Helaas is veelal de
              wettelijk verplichte bijstand door een advocaat in het jeugdrecht
              door bezuinigingen verdwenen. Dit betekent echter niet dat jij en
              je kind geen recht hebben op gefinancierde rechtsbijstand. Helaas
              weten veel ouders en minderjarigen dit niet en gaan zij zonder
              deskundige bijstand het gesprek aan. Dit is niet verstandig omdat
              een ondertoezichtstelling en een uithuisplaatsing ernstige
              gevolgen kunnen hebben voor het gezag van de ouders en mogelijk
              terugplaatsing naar huis.
              <br /><br />
              Hier is het daarom van heel groot belang dat zodra jij en je
              kind(eren) te maken krijgen met hulpverlening je contact opneemt
              met een advocaat welke gespecialiseerd is in het jeugdrecht.
            </p>
          </div>
        </div>
      </div>
    </section>

    <footer
      class="bg-gray-800 text-cognac-light text-center p-6 text-xs text-white"
    >
      © {{ new Date().getFullYear() }} Helleman Advocaten | Realisatie:
      <a href="https://egidius.nl" target="_blank" class="hover:underline"
        >Egidius IT</a
      >
    </footer>
  </div>
</template>

<script>
import Header from "../components/Header";

export default {
  name: "Rechtsgebieden",
  components: {
    Header
  }
};
</script>
